/* KK okos fotó-ellenőrzés a termékoldalon (J-93)
 * 1) A Teeinblue fotómezőibe (input#tee-photo-layer-*) választott fájlt a böngésző ugyanúgy elemzi, mint a segédlet oldalon
 *    (assets/kk-fotocheck.js, lustán töltve), és a mező alá címkét tesz. A feltöltést nem akadályozza, a fájl nem hagyja el az eszközt.
 * 2) A fotómezők fölött „Fotótippek és okos ellenőrző” gomb: felugró ablakban a teljes ellenőrző.
 * 3) Kosárba tételkor az összegzés rendelés-attribútumba kerül (ATTR), hogy a gyártásnál látszódjon.
 * 4) Ha van gyenge (piros) fotó, kosárba tétel előtt megkérdezzük: lecseréli, vagy így kéri (a döntés is naplózva).
 */
(() => {
  const S = document.currentScript || {}, D = S.dataset || {};
  const LIB = D.lib, CSS = D.css, PAGE = D.page || '/pages/fotofeltoltesi-segedlet';
  const MIN = +D.min || 1200, GOOD = +D.good || 2000;
  const ATTR = 'Fotó-ellenőrzés';
  const ATC = '.tee-btn--atc, form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"]';
  const handle = decodeURIComponent((location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '');
  const res = new Map(), pending = new Map();
  const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = (n, d) => { try { window.KK && KK.track && KK.track(n, d); } catch (e) { /* mérés nélkül is működik */ } };
  const escH = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let libP = null;
  const lib = () => libP || (libP = new Promise((ok, no) => {
    if (CSS && !document.querySelector('link[data-kkf-css]')) { const l = document.createElement('link'); l.rel = 'stylesheet'; l.href = CSS; l.dataset.kkfCss = ''; document.head.append(l); }
    if (window.KKF) return ok(window.KKF);
    const s = document.createElement('script'); s.src = LIB; s.onload = () => (window.KKF ? ok(window.KKF) : no(new Error('KKF'))); s.onerror = no; document.head.append(s);
  }));

  const fieldOf = (id) => { const i = document.getElementById(id); return i ? i.closest('.tee-field--photo') : null; };
  const isEmpty = (fld) => !fld || !!fld.querySelector('.tee-photo-placeholder');
  const SHORT = { good: 'Éles, mehet', warn: 'Nézd meg a megjegyzést', bad: 'Ez kevés lesz a nyomtatáshoz' };

  /* ---------- 1) címke a fotómező alatt ---------- */
  function paint(id) {
    const fld = fieldOf(id), x = res.get(id);
    let b = fld && fld.querySelector('.kkf-badge');
    if (!fld || !x) { if (b) b.remove(); return; }
    if (!b) { b = document.createElement('div'); b.className = 'kkf-badge'; b.setAttribute('role', 'status'); fld.append(b); }
    if (x.busy) { b.className = 'kkf-badge is-busy'; b.innerHTML = '<span class="kkf-badge__dot"></span><span class="kkf-badge__t">Fotó ellenőrzése…</span>'; return; }
    const lvl = x.level, note = x.err ? 'A böngésződ nem tudta megnyitni (gyakran HEIC). A legbiztosabb a JPEG vagy PNG.' : (lvl === 'good' ? '' : ((lvl === 'bad' && x.out.r.notes.find((n) => / px/.test(n))) || x.out.r.notes[0] || ''));
    b.className = `kkf-badge kkf-badge--${lvl}`;
    b.innerHTML = `<span class="kkf-badge__dot" aria-hidden="true"></span><span class="kkf-badge__txt"><span class="kkf-badge__t">${SHORT[lvl]}</span>${note ? `<span class="kkf-badge__d">${escH(note)}</span>` : ''}</span>${x.out ? '<button type="button" class="kkf-badge__more">Részletek</button>' : ''}`;
    const more = b.querySelector('.kkf-badge__more');
    if (more) more.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); details(id); });
  }

  document.addEventListener('change', (e) => {
    const inp = e.target;
    if (!inp || inp.type !== 'file' || !/^tee-photo-layer-/.test(inp.id || '')) return;
    const f = inp.files && inp.files[0]; if (!f) return;
    const id = inp.id, tok = {}; pending.set(id, tok);
    const old = res.get(id); if (old && old.url) URL.revokeObjectURL(old.url);
    const t0 = Date.now();
    res.set(id, { busy: true, name: f.name, t: t0 }); paint(id);
    lib().then(async (K) => {
      let out = null; try { out = await K.check(f, MIN, GOOD); } catch (er) { out = null; }
      if (pending.get(id) !== tok) return;
      if (!out) { res.set(id, { name: f.name, level: 'warn', err: true, t: t0 }); paint(id); track('kk_fotocheck_pdp', { level: 'err' }); return; }
      const twin = [...res.entries()].find(([k, v]) => k !== id && v.out && K.ham(v.out.a.hash, out.a.hash) <= 5);
      if (twin) { if (out.r.level === 'good') out.r.level = 'warn'; out.r.notes.unshift(`Nagyon hasonlít egy másik feltöltött fotódra (${twin[1].name}). Ha nem szándékos, válassz helyette másikat.`); }
      res.set(id, { name: f.name, level: out.r.level, out, f, url: URL.createObjectURL(f), t: t0 });
      paint(id); track('kk_fotocheck_pdp', { level: out.r.level });
    }).catch(() => { res.delete(id); paint(id); });
  }, true);

  /* ---------- felugró ablak (részletek és teljes ellenőrző) ---------- */
  let dlg = null, after = null;
  function dialog(html, onClose) {
    if (!dlg) {
      dlg = document.createElement('dialog'); dlg.className = 'kk-digi-modal kkf-modal'; document.body.appendChild(dlg);
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close('cancel'); });
      dlg.addEventListener('close', () => { const fn = after; after = null; if (fn) fn(dlg.returnValue || ''); });
    }
    dlg.innerHTML = html; after = onClose || null; dlg.returnValue = '';
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
  }
  const X = '<button type="submit" value="cancel" class="kk-digi-modal__x" aria-label="Bezárás">&times;</button>';
  async function details(id) {
    const x = res.get(id); if (!x || !x.out) return;
    const K = await lib();
    dialog(`<form method="dialog" class="kk-digi-modal__box kkf-modal__box">${X}<p class="kk-digi-modal__eyebrow"><span>Okos fotó-ellenőrző</span></p>${K.card(x.f, x.out, x.url)}
      <p class="kkf-modal__foot">A fotó nem töltődik fel sehova az ellenőrzéshez. <a href="${PAGE}" target="_blank" rel="noopener">Összes fotótipp</a></p></form>`);
    track('kk_fotocheck_pdp_details', { level: x.level });
  }
  async function fullChecker() {
    await lib();
    dialog(`<form method="dialog" class="kk-digi-modal__box kkf-modal__box">${X}
      <p class="kk-digi-modal__eyebrow"><span>Okos fotó-ellenőrző</span></p>
      <h2 class="kk-digi-modal__title">Jó lesz ez a fotó? Nézzük meg!</h2>
      <kk-fotocheck class="kkf__box" data-min="${MIN}" data-good="${GOOD}" data-max-files="10">
        <label class="kkf__drop" data-kkf-drop><input type="file" accept="image/*" multiple class="kkf__input" data-kkf-input>
          <span class="kkf__drop-t">Fotók kiválasztása</span><span class="kkf__drop-d">egyszerre legfeljebb 10 kép</span></label>
        <p class="kkf__privacy">A fotóid nem töltődnek fel sehova: az ellenőrzés a saját eszközödön fut. Utána a termék fotómezőiben töltsd fel őket.</p>
        <div class="kkf__results" data-kkf-results aria-live="polite"></div>
      </kk-fotocheck>
      <p class="kkf-modal__foot"><a href="${PAGE}" target="_blank" rel="noopener">Összes fotótipp és képarány</a></p></form>`);
    track('kk_fotocheck_pdp_open');
  }

  /* ---------- 2) gomb a fotómezők fölött ---------- */
  function intro() {
    const first = document.querySelector('.tee-customization-form .tee-field--photo');
    if (!first) return;
    if (first.previousElementSibling && first.previousElementSibling.classList.contains('kkf-intro-row')) return;
    const old = document.querySelector('.kkf-intro-row'); if (old) old.remove();
    const b = document.createElement('button'); b.type = 'button'; b.className = 'kkf-intro';
    b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 8a2 2 0 0 1 2-2h2l1.5-2h5L16 6h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="12" cy="12.5" r="3.5" fill="none" stroke="currentColor" stroke-width="1.8"/></svg><span>Fotótippek és okos ellenőrző</span>';
    b.addEventListener('click', (e) => { e.preventDefault(); fullChecker(); });
    const row = document.createElement('div'); row.className = 'kkf-intro-row'; row.append(b);
    first.before(row);
  }

  /* ---------- karbantartás: Teeinblue újrarajzolás, törölt fotó ---------- */
  function sync() {
    if (!document.querySelector('.tee-customization-form')) return;
    intro();
    for (const id of [...res.keys()]) {
      const fld = fieldOf(id);
      const x0 = res.get(id);
      // a Teeinblue a kivágó ablak lezárásáig üresnek mutatja a mezőt: csak akkor töröljük, ha már láttuk kitöltve, vagy 2 perce üres
      if (fld && !isEmpty(fld)) x0.filled = true;
      if (!fld || (!x0.busy && isEmpty(fld) && (x0.filled || Date.now() - x0.t > 120000))) { const x = res.get(id); if (x && x.url) URL.revokeObjectURL(x.url); res.delete(id); if (fld) paint(id); continue; }
      if (!fld.querySelector('.kkf-badge')) paint(id);
    }
  }
  setInterval(() => { if (!document.hidden) sync(); }, 1200);
  [600, 2000, 4000].forEach((ms) => setTimeout(sync, ms));

  /* ---------- 3) és 4) kosárba tétel ---------- */
  const live = () => [...res.entries()].filter(([id, x]) => !x.busy && fieldOf(id) && (!isEmpty(fieldOf(id)) || Date.now() - x.t < 120000)).map(([, x]) => x);
  const summary = (L) => {
    const c = { good: 0, warn: 0, bad: 0 }; L.forEach((x) => { c[x.level]++; });
    const bad = L.filter((x) => x.level === 'bad').map((x) => `${x.name}${x.out ? ` (${x.out.r.L} px)` : ''}`);
    return `${L.length} fotó: ${c.good} rendben, ${c.warn} megnézendő, ${c.bad} gyenge${bad.length ? `; gyenge: ${bad.join(', ')}` : ''}`;
  };
  let accepted = '', logged = '';
  const log = (sum, extra) => { if (window.KK && KK.attrLog) KK.attrLog(ATTR, 'termékoldal', handle, sum + (extra ? ` | ${extra}` : '')); };
  window.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest(ATC);
    if (!btn) return;
    const L = live(); if (!L.length) return;
    const sum = summary(L), bad = L.filter((x) => x.level === 'bad');
    if (bad.length && accepted !== sum) {
      e.preventDefault(); e.stopImmediatePropagation();
      const n = bad.length;
      dialog(`<form method="dialog" class="kk-digi-modal__box">${X}
        <p class="kk-digi-modal__eyebrow"><span>Egy gyors kérdés</span></p>
        <h2 class="kk-digi-modal__title">${n === 1 ? '1 fotó' : `${n} fotó`} kevés lesz a nyomtatáshoz</h2>
        <p class="kk-size-modal__lead">${n === 1 ? 'Ez a fotó kicsi, nyomtatásban homályos lehet' : 'Ezek a fotók kicsik, nyomtatásban homályosak lehetnek'}. Ha megvan az eredeti, nagyobb fájl, cseréld le rá.</p>
        <ul class="kkf-modal__list">${bad.map((x) => `<li><b>${escH(x.name)}</b>: a hosszabbik oldala ${x.out.r.L} px</li>`).join('')}</ul>
        <div class="kk-digi-modal__actions"><button type="submit" value="swap" class="kk-digi-modal__ok" autofocus>Lecserélem</button>
        <button type="submit" value="keep" class="kk-size-modal__keep">Így is kérem</button></div></form>`, (v) => {
        if (v === 'keep') { accepted = sum; logged = sum; log(sum, 'gyenge fotó elfogadva'); track('kk_fotocheck_pdp_atc', { action: 'keep', bad: n }); btn.click(); }
        else {
          track('kk_fotocheck_pdp_atc', { action: v === 'swap' ? 'swap' : 'cancel', bad: n });
          if (v === 'swap') { const id = [...res.entries()].find(([, x]) => x === bad[0]); const fld = id && fieldOf(id[0]); if (fld) fld.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'center' }); }
        }
      });
      return;
    }
    if (logged !== sum) { logged = sum; log(sum); }
  }, true);
})();
